import React from "react";
import { Field } from "formik";
import { pipe } from "ramda";
import { Input } from "reactstrap";

import { withLabel, withFormGroup, withError } from "../hocs";
import DatePicker from "./DatePicker";
import toClass from "../../utilities/toClass";

// workaround that's needed because of react-datepicker
const InputWithError = pipe(withError, toClass)(Input);

const LabeledDatePicker = pipe(
  withLabel,
  withFormGroup
)((fieldProps) => (
  <Field
    {...fieldProps}
    type="date"
    component={(props) => (
      <DatePicker
        {...props}
        customInput={
          <InputWithError
            field={props.field}
            form={props.form}
            className={props.className}
          />
        }
      />
    )}
  />
));

export default LabeledDatePicker;



// WEBPACK FOOTER //
// ./src/components/formik/LabeledDatePicker.jsx